import keyBy from 'lodash/keyBy';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import { CorrectFtbAnswersFragment } from '@/modules/corporate/modules/quiz/views/QuizPlayer/graphql/fragments/generated/QuestionPerformance';
import { QuizPlayerQuestionContentFragment } from '@/modules/corporate/modules/quiz/views/QuizPlayer/graphql/fragments/generated/QuizPlayerQuestionContent';

import AnswerMap from '../AnswerMap';

interface CorrectAnswersProps {
  className?: string;
  ftbComponents: QuizPlayerQuestionContentFragment['ftbComponents'];
  correctFtbAnswers: CorrectFtbAnswersFragment[];
}

const CorrectAnswers: React.FC<CorrectAnswersProps> = ({
  ftbComponents,
  correctFtbAnswers,
  className,
}) => {
  const { t } = useTranslation();
  const correctAnswersById = keyBy(correctFtbAnswers, 'id');
  const blanks = ftbComponents.filter((ftbComponent) => ftbComponent.isBlank);

  return (
    <Stack
      className={cn(
        'p-12 rounded-6 border border-border-success-dark bg-bg-success-light',
        className,
      )}
      direction="col"
      gapY={12}>
      <Typography color="text-text-success-dark" variant="body-short-02">
        {t('QuizPlayer:CorrectAnswer')}
      </Typography>
      {blanks.map((ftbComponent, index) => {
        if (!ftbComponent.isBlank) {
          return null;
        }

        const correctAnswer = correctAnswersById[ftbComponent.id];

        return (
          <AnswerMap
            key={ftbComponent.id}
            labelLeft={t('QuizPlayer:BlankIndex', {
              index: index + 1,
            })}
            labelRight={correctAnswer?.text || ''}
          />
        );
      })}
    </Stack>
  );
};

export default CorrectAnswers;
